module.exports = __webpack_public_path__ + "img/sensor_ok.3f2c2a53.svg";